import React, { useEffect, useState } from "react";

//This is the small component used in page content headers where the name of the main menu item is displayed
// as where the user is, it receives the information as props in the component, varying on the page name.

// Also minimizing the desktop navigation is handled here, the trigger of this function is <button className="header-button">

const ContentHeader = (props) => {
  const [MenuIsOpen, setMenuIsOpen] = useState(false);

  useEffect(() => {
    if (window.localStorage.getItem("MenuIsEmpty") === "0") {
      if (window.localStorage.getItem("MenuIsOpen") === "0") {
        document
          .getElementById("burger-button")
          .classList.remove("burger-to-arrow");
      }
      setTimeout(() => {
        if (window.innerWidth > 450) {
          if (window.localStorage.getItem("MenuIsOpen") === "1") {
            openMenu();
            setMenuIsOpen(true);
          } else {
            closeMenu();
            setMenuIsOpen(false);
          }
        }
      }, 300);
    }
  }, []);

  const handleMinimize = () => {
    if (window.innerWidth > 450) {
      setMenuIsOpen(!MenuIsOpen);
      if (MenuIsOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    }
  };

  const openMenu = () => {
    if (document.getElementById("dashboard-content")) {
      document
          .getElementById("dashboard-content")
          .classList.add("content-translated");
      setTimeout(() => {
        document
            .getElementById("dashboard-content")
            .classList.add("content-no-animation");
      }, 500);
      document.getElementById("main-nav").style.transform = "translateX(0px)";
      window.localStorage.setItem("MenuIsOpen", 1); //0: false 1: true
      document.getElementById("burger-button").classList.add("burger-to-arrow");
      document.getElementById("page-wrapper").classList.remove("full-width");
      setTimeout(() => {
        document
            .getElementById("dashboard-content")
            .setAttribute("style", "transition-duration: unset !important");
      }, 401);
      setTimeout(() => {
        document
            .getElementById("dashboard-content")
            .setAttribute("style", "transition-duration: 0.4s !important");
      }, 600);
      if (window.innerWidth >= 600 && window.innerWidth <= 1024){
        document.getElementById("main-nav").style.display = "block";
        document
            .getElementById("dashboard-content")
            .setAttribute("style", "transition-duration: unset !important");
        document
            .getElementById("dashboard-content")
            .classList.add("content-no-animation");
      }
    }
  };

  const closeMenu = () => {
    document
        .getElementById("dashboard-content")
        .setAttribute("style", "transition-duration: 0.4s !important");
    document
      .getElementById("dashboard-content")
      .classList.remove("content-translated");
    document.getElementById("main-nav").style.transform = "translateX(-990px)";
    window.localStorage.setItem("MenuIsOpen", 0); //0: false 1: true
    document
      .getElementById("burger-button")
      .classList.remove("burger-to-arrow");
    document.getElementById("page-wrapper").classList.add("full-width");
    document
        .getElementById("dashboard-content")
        .classList.remove("content-no-animation");
    if (window.innerWidth >= 600 && window.innerWidth <= 1024){
      document.getElementById("main-nav").style.display = "none";
    }
  };

  return (
    <div className="content-header">
      {window.localStorage.getItem("MenuIsEmpty") === "0" ? (
        <button className="header-button" onClick={() => handleMinimize()}>
          <div
            id="burger-button"
            className={
              window.localStorage.getItem("MenuIsOpen") === "1"
                ? "burger-to-arrow"
                : ""
            }
          >
            <div id="top-line"></div>
            <div id="mid-line"></div>
            <div id="bot-line"></div>
          </div>
        </button>
      ) : null}

      <h1
        className="page-title"
        style={
          window.localStorage.getItem("MenuIsEmpty") === "0"
            ? null
            : { margin: "0" }
        }
      >
        {props.PageName}
      </h1>
    </div>
  );
};
export default ContentHeader;
